/* Вход по e-mail или телефону. В демо-режиме — быстрый вход под любой ролью. */
import { useQuery } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { ROLES, type Me, type Role } from "@okno/shared";
import { api, errorText } from "../lib/api";
import { Icon } from "../ui/Icon";

interface Meta {
  demo: boolean;
  demoPassword?: string;
  demoUsers: { name: string; role: Role; login: string }[];
}

const ROLE_ICON: Record<Role, string> = { owner: "shield", manager: "chart", admin: "clipboard", worker: "wrench" };

export function LoginScreen({ onLogin }: { onLogin: (me: Me) => void; from?: string }) {
  const meta = useQuery({ queryKey: ["meta"], queryFn: () => api.get<Meta>("/meta") });
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(l: string, p: string) {
    setBusy(true);
    setError("");
    try {
      onLogin(await api.post<Me>("/auth/login", { login: l, password: p }));
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    void submit(login.trim(), password);
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16, background: "var(--bg)" }}>
      <div className="panel panel-body stack" style={{ width: "100%", maxWidth: 400 }}>
        <div className="brand" style={{ padding: 0 }}>
          <span className="brand-mark">
            <span />
          </span>
          <span>
            <span className="brand-name">Окно</span>
            <span className="brand-sub">CRM для моек и СТО</span>
          </span>
        </div>
        <h1 style={{ fontSize: 22, margin: "8px 0 0" }}>Вход</h1>
        <form className="stack" onSubmit={onSubmit}>
          <label className="field">
            <span>E-mail или телефон</span>
            <input className="input" autoComplete="username" value={login} onChange={(e) => setLogin(e.target.value)} required autoFocus />
          </label>
          <label className="field">
            <span>Пароль</span>
            <input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          {error ? (
            <div className="callout callout-bad" role="alert">
              <Icon name="alert" size={16} />
              <span>{error}</span>
            </div>
          ) : null}
          <button className="btn btn-primary btn-lg btn-block" disabled={busy}>
            {busy ? "Входим…" : "Войти"}
          </button>
        </form>
        {meta.data?.demo && meta.data.demoUsers.length ? (
          <div className="stack stack-sm">
            <div className="section-title">Демо: войти как</div>
            {meta.data.demoUsers.map((u) => (
              <button key={u.login} className="btn btn-block" style={{ justifyContent: "flex-start" }} disabled={busy} onClick={() => void submit(u.login, meta.data!.demoPassword || "")}>
                <Icon name={ROLE_ICON[u.role]} />
                {ROLES[u.role]}
                <span className="muted" style={{ marginLeft: "auto", fontSize: 13 }}>
                  {u.name}
                </span>
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
